// Generated by ReScript, PLEASE EDIT WITH CARE


function getStringFromType(category_type) {
  switch (category_type) {
    case /* TwoWheelers */0 :
        return "Two Wheelers";
    case /* Trucks */1 :
        return "Trucks";
    case /* PackersAndMovers */2 :
        return "Packers & Movers";
    case /* Courier */3 :
        return "Intercity Courier Service";
    
  }
}

function getTypeFromString(category) {
  switch (category) {
    case "All India Parcel" :
    case "Courier" :
    case "Courier Service" :
    case "Courier Services" :
    case "Intercity" :
    case "Intercity Courier Service" :
        return /* Courier */3;
    case "Packers & Movers" :
        return /* PackersAndMovers */2;
    case "Trucks" :
        return /* Trucks */1;
    case "Two Wheelers" :
        return /* TwoWheelers */0;
    default:
      return ;
  }
}

function getTypeFromStringV2(category) {
  switch (category) {
    case "courier" :
        return /* Courier */3;
    case "pnm" :
        return /* PackersAndMovers */2;
    case "trucks" :
        return /* Trucks */1;
    case "two-wheelers" :
        return /* TwoWheelers */0;
    default:
      return /* Trucks */1;
  }
}

function getStringFromTypeV2(category_type) {
  switch (category_type) {
    case /* TwoWheelers */0 :
        return "two-wheelers";
    case /* Trucks */1 :
        return "trucks";
    case /* PackersAndMovers */2 :
        return "pnm";
    case /* Courier */3 :
        return "courier";
    
  }
}

export {
  getStringFromType ,
  getTypeFromString ,
  getTypeFromStringV2 ,
  getStringFromTypeV2 ,
}
/* No side effect */
